import React, { useEffect, useState } from "react";
import { Alert, Col, Row } from '@intech/web-ui';

import { FuncionarioService, DependenteService } from "../../services";
import { FuncionarioDados, DependenteEntidade } from "../../entidades";
import { useHistory } from "react-router-dom";

import { DadosPessoais } from "./DadosPessoais";
import { Endereco } from "./Endereco";
import { DadosBancarios } from "./DadosBancarios";
import { LoadingComponent } from "../../components/LoadingComponent";
import { Dependentes } from "./Dependentes";
import { MasterPage } from "../../components/MasterPage";
import { NumFuncionalidade } from "../../helpers/BloqueioFuncionalidade";

export const Dados: React.FC = (props) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [Dados, setDados] = useState<FuncionarioDados>();
  const [ListaDependentes, setListaDependentes] = useState<Array<DependenteEntidade>>();

  useEffect(() => {
    (async () => {
      try {
        const pensionista = localStorage.getItem("pensionista") === "true";

        if (!pensionista) {
          const ListaDependentes = await DependenteService.Buscar();
          setListaDependentes(ListaDependentes);
        }

        const Dados = await FuncionarioService.Buscar();
        setDados(Dados);

      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
        else {
          const error = err.response ? err.response.data : err;
          console.log(error);
          setAlertText(error);
        }
      }
    })();
  }, []);

  function renderDados() {
    if (Dados !== undefined) {
      return (<>
        <Row>
          <Col>
            <DadosPessoais dados={Dados} />
          </Col>

          <Col>
            <Endereco entidade={Dados.Entidade} />

            <DadosBancarios entidade={Dados.Entidade} />

            <Dependentes dependentes={ListaDependentes} />
          </Col>
        </Row></>
      );
    }

    if (AlertText !== "") {
      return (
        <Alert type={"danger"}>
          {AlertText}
        </Alert>
      );
    }

    return <LoadingComponent />;
  }

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.SEUS_DADOS} {...props}>
      {renderDados()}
    </MasterPage>

  );
}
